import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const useNotificationStore = create()(persist((set) => ({
    isNotificationVisible: false,
    openNotification: () => set({ isNotificationVisible: true }),
    closeNotification: () => set({ isNotificationVisible: false }),
}), { name: 'notification', storage: createJSONStorage(() => sessionStorage) }));
export default useNotificationStore;
